module.exports = __webpack_public_path__ + "media/earth.a32cfaba.mp3";